import React, { Component } from "react";
import * as aor from "react-admin";
import { withStyles } from "@material-ui/core";

const styles = {
    inlineBlock: { display: "inline-flex", marginRight: "1rem" }
};

class MyBooleanInput extends Component {
    state = { lock: false };

    componentDidMount() {
        const { lock } = this.props;
        this.setState({ lock: lock });
    }

    handleChange = () => {
        this.setState({ lock: !this.state.lock });
    };

    render() {
        const { id, label } = this.props;
        return (
            <React.Fragment>
                <aor.BooleanInput
                    source={id}
                    label={label}
                    options={{
                        checked: this.state.lock,
                        onChange: this.handleChange
                    }}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(MyBooleanInput);



// WEBPACK FOOTER //
// ./src/components/MyBooleanInput.js